import React, { useState, useEffect } from "react";
import { Row, Col, Button, Divider } from "antd";
import { MsgBox, isMobile } from "../../../../shared/custom-ant-d";
import {
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  UndoOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import SignPad from "./_SignPad";
import PDFViewer from "pdf-viewer-reactjs";
import {
  reqPostDownloadBase64,
  reqPutDownloadFile,
  reqPostSaveOnboardingDocument,
} from "../../../../axios/api";

const contentType = "application/pdf";
const zoomForDesktop = "100";
export const _OpenDoc = (props) => {
  const {
    setOnboardingDocumentList,
    onboardingDoc,
    setOnboardingDoc,
    setPageLoading,
    setShowButtons,
    isSigned,
    signature,
    setSignature,
    Auth,
  } = props;

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [showSignPad, setShowSignPad] = useState(false);

  useEffect(() => {
    if (pdfBlobUrl == null && onboardingDoc != null) {
      setPageLoading(true);
      setShowButtons(false);
      var formData = new FormData();
      var filename =
        onboardingDoc.StaticAzureContainerPath + onboardingDoc.StaticFileName;
      formData.append("blobcontainer", onboardingDoc.AzureContainerName);
      formData.append("filename", filename);
      reqPostDownloadBase64(formData)
        .then((res) => {
          if (res.data.isSuccess) {
            let blob = b64toBlob(res.data.fileObj, contentType);
            let blobUrl = URL.createObjectURL(blob);
            setPdfBlobUrl(blobUrl);
          } else {
            setOnboardingDoc(null);
            MsgBox({
              type: "error",
              message: "",
              description: "File does not exist.",
            });
          }
          setPageLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [pdfBlobUrl]);

  const handleDownload = () => {
    var formData = new FormData();
    var filename =
      onboardingDoc.StaticAzureContainerPath + onboardingDoc.StaticFileName;
    formData.append("blobcontainer", onboardingDoc.AzureContainerName);
    formData.append("filename", filename);
    reqPutDownloadFile(formData)
      .then((res) => {
        generateDownloadLink(res.data, filename, res.headers["content-type"]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const generateDownloadLink = (theBlob, fileName, contentType) => {
    var blob = new Blob([theBlob], { type: contentType });
    var blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = blobUrl;
    link.download = fileName;

    document.body.appendChild(link);

    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  };
  const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {
      type: contentType,
      headers: {
        filename: "test.pdf",
      },
    });
    return blob;
  };

  const onSubmit = (signature) => {
    setSignature(signature);
    const payload = {
      ...onboardingDoc,
      ...{
        UpdatedBy: `${Auth.firstName} ${Auth.lastName}`,
        UpdatedDt: new Date(),
        SignatureDt: new Date(),
        SignatureImage:
          signature != null
            ? signature.replace("data:image/png;base64,", "")
            : null,
      },
    };

    let lstObj = [];
    lstObj.push(payload);
    const payloadStr = JSON.stringify(lstObj);

    reqPostSaveOnboardingDocument(payloadStr)
      .then((res) => {
        if (res.data.isSuccess) {
          MsgBox({
            type: "success",
            message: "",
            description: "Your document has successfully been signed.",
          });
        } else {
          MsgBox({
            type: "error",
            message: "",
            description: res.data.errorMessage,
          });
        }
        setOnboardingDoc(null);
        setOnboardingDocumentList(null);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const CustomNavigation = (data) => {
    const { page, pages } = data;
    const { handlePrevClick, handleNextClick } = data;
    const {
      handleZoomIn,
      handleResetZoom,
      handleZoomOut,
      maxScale,
      minScale,
      scale,
    } = data;

    return (
      <div className="custom-pdf-viewer-navigation">
        <Row>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Previous"
              onClick={handlePrevClick}
              disabled={page === 1}
            >
              <LeftOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <span
              style={{
                display: "inline-block",
                marginTop: "5px",
                color: "white",
              }}
            >
              Page {page} from {pages}
            </span>
          </Col>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Next"
              onClick={handleNextClick}
              disabled={page === pages}
            >
              <RightOutlined />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Zoom In"
              onClick={handleZoomIn}
              disabled={maxScale == scale}
            >
              <ZoomInOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <Button
              title="Zoom Reset"
              className="custom-pdf-nav-btn"
              onClick={handleResetZoom}
            >
              <UndoOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Zoom Out"
              onClick={handleZoomOut}
              disabled={minScale == scale}
            >
              <ZoomOutOutlined />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Button
              className="custom-pdf-nav-btn"
              title="Download"
              onClick={handleDownload}
            >
              <DownloadOutlined />
            </Button>
          </Col>
        </Row>
      </div>
    );
  };
  const CustomPDFViewer = () => {
    return (
      <>
        <PDFViewer
          document={{
            url: pdfBlobUrl,
          }}
          navigation={CustomNavigation}
          navbarOnTop={true}
        />
      </>
    );
  };

  return (
    <>
      {pdfBlobUrl !== null ? (
        <>
          {isMobile ? (
            <CustomPDFViewer />
          ) : (
            <object
              data={pdfBlobUrl + "#zoom=" + zoomForDesktop}
              type={contentType}
              width="100%"
              height="800px"
            >
              {/* commented component below as found bug when signature popup and looses pdf display
                  --Janno 5/4/22
              */}
              {/* <CustomPDFViewer /> */}
            </object>
          )}
          <Row>
            <Col md={24}>
              <Divider orientation="left"></Divider>
            </Col>
            <SignPad
              {...{ showSignPad, setShowSignPad, signature }}
              onSignPadOk={(e) => {
                if (e !== null) {
                  onSubmit(e);
                } else {
                  setSignature(null);
                }
              }}
            />
          </Row>
          <Row justify="center">
            <Col md={{ span: 4 }} sm={23} xs={24}>
              <Button
                type="danger"
                htmlType="button"
                onClick={() => {
                  setOnboardingDoc(null);
                  setShowButtons(true);
                }}
              >
                Back
              </Button>
              {!isSigned ? (
                <>
                  {"  "}
                  <Button
                    type="danger"
                    htmlType="button"
                    onClick={() => {
                      setShowSignPad(true);
                    }}
                  >
                    Sign
                  </Button>
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
